import styled from "styled-components";

export const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 100px 40px;
    background-color: var(--primary);
    gap: 25px;

  @media (max-width: 600px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 40px 15px;
  }
`

export const Logo = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  img {
    width: 200px;
    z-index: 2;
    @media (max-width: 768px) {
      width: 100px;
    }
  }

  p {
    position: absolute;
    padding: 0 70px;
    bottom: 28px;
    color: var(--gold);
    font-size: 0.8rem;
    z-index: 1;
    @media (max-width: 768px) {
      font-size: 0.5rem;
      padding: 0 30px;
    }
  }
`

export const Item = styled.div`
    h3{
        margin-bottom: 10px;
        @media (max-width: 768px) {
            font-size: 1rem;
        }
    }

    ul{
        list-style: none;
        padding: 0;

        li{
            display: flex;
            align-items: center;
            padding: 12px 0;
            color: var(--gold);
            transition: all 0.3s ease;
            
            @media (max-width: 768px) {
                padding: 6px 10px;
            }

            a {
                text-decoration: none;
                color: var(--gold);
                display: flex;
                align-items: center;

                svg {
                    transition: transform 0.3s ease, color 0.3s ease;
                }

                span {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    @media (max-width: 768px) {
                        font-size: 0.8rem;
                    }
                }
            }
            
            span {
                @media (max-width: 768px) {
                    font-size: 0.8rem;
                }
            }

            &:hover {
                transform: scale(1.2);
                color: var(--primary);
            }

        }
    }
`

export const Copyright = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 150px;
  border-top: 1px solid rgba(0,0,0,0.1);
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
    text-align: center;
  }

  p{
    color: var(--gold);
  }

  ul{
    list-style: none;
    padding: 0;

    li{
        display: flex;
        align-items: center;
        padding: 12px 0;
        color: var(--gold);
        transition: all 0.3s ease;
        
        @media (max-width: 768px) {
            padding: 6px 10px;
        }

        a {
            text-decoration: none;
            color: var(--gold);
            display: flex;
            align-items: center;

            svg {
                transition: transform 0.3s ease, color 0.3s ease;
            }

            span {
                display: flex;
                align-items: center;
                gap: 10px;

                @media (max-width: 768px) {
                    font-size: 0.8rem;
                }
            }
        }
        
        span {
            @media (max-width: 768px) {
                font-size: 0.8rem;
            }
        }
    }
  }
`;
